import fizapilib from "./fizapilib.auto.ts";
import FizConfig from "../FizConfig.ts";
import * as progressbar from "../util/progressbar.ts";
import * as Storage from "../lib/Storage.ts";
import * as libLocation from "../lib/location.ts";
import $ from "../$.js";
import {getAuthorization} from "./Authorization.ts";
import * as CustomInput from "../util/CustomInput.ts";
import { fromZone } from "../lib/TimezoneUtils.ts";

var webapiurlFromUrl = libLocation.getURLParam("webapiurl");
if(webapiurlFromUrl){
  Storage.sessionSet("webapiurl",webapiurlFromUrl);
}

fizapilib.types.AccountLoginInfo.prototype.onDecode = function(json){
  if(json.webApiUrl){
    Storage.sessionSet("webapiurl",json.webApiUrl);
  }
}
  var
    // Constant aliases
    API = FizConfig.API_BASE_URL+"api",
    rethrow = function(e){throw e;},
    defaultErrorHandler = rethrow,
    noop = (a)=>a,

    //TODO code something to disallow call while previous one is not finished
    autogroup = {
      timeout:null,
      apis:[],
      after:[],
      push:function(apiCall){
        this.apis.push(apiCall);
        if(this.timeout===null){
          var self = this;
          this.timeout=setTimeout(function(){self.execute()},20);
        }
      },
      options:undefined,
      execute:function(){
        var after = this.after;
        try{
          buildGroupApiCall(this.apis,function(){
            for(var i=0;i<after.length;i++){
              //TODO maybe try catch maybe not
              after[i]();
            }
          },null,this.options)();
        }finally{
          this.apis = [];
          this.after = [];
          this.options = undefined;
          this.timeout=null;
        }
      }
    };
    function a0i(i){
      return i<10?'a0'+i:'a'+i;
    }


    function chainSuccess(success,newSuccess){
      if(!newSuccess) return success;
      if(!success) return newSuccess;
      return function(param){
        var
          subresult = success.call(this,param),
          result = newSuccess.call(this,subresult);
        return result==undefined?subresult:result;
      };
    }
    //return a function that execute newError and if it throws something give it to the previous handler
    function chainError(error,newError){
      if(!newError) return error;
      if(!error) return newError;
      return function(){
        try{
          newError.apply(this,arguments);
        }catch(e){
          error.apply(this,arguments);
        }
      };
    }

    class HTTPError extends Error{
      constructor(code,message){
        super(message)
        this.code = code;
        this.message = message;
        this.toString = function(){ return this.code+" "+this.message;};
      }
    }


  function buildApiCall(definition,data,success,error,options){

    function setOptions(opt){
      return buildApiCall(definition,data,success,error,Object.assign({},options,opt));
    }
    function prepareInternal(newData,newSuccess,newError){
      return buildApiCall(definition,Object.assign({},data,newData),chainSuccess(success,newSuccess),chainError(error,newError),options);
    }
    function prepare(a,b,c){
      if(a && typeof a==='object' && !(a instanceof Array) && !(a instanceof fizapilib.types.ServerBeanPrototype)){
        //console.log("unrecommended prepare ",new Error())
        //in this case we give directly a data object
        if(a instanceof $){
          a = a.get(0);
        }
        if(a.nodeName){
          return prepareInternal(flattenForm(a),b,c);
        }else{
          return prepareInternal(a,b,c);
        }
      }
      var
       newData={};
      //we use the definition to fill the datas
      for(var i=0,length = Math.min(definition.argumentsName.length,arguments.length);i<length;i++){
        var
          value = arguments[i],
          argDefinition = definition.argumentsName[i],
          trueDefinition = typeof argDefinition==='string'?{name:argDefinition}:argDefinition,
          name = trueDefinition.name;
        //in case it is a function it is success one
        if(typeof value==='function'){
          break;
        }
        if(value==null){
          continue;
        }

        if(trueDefinition.encode){
          value = trueDefinition.encode(value);
        }
        //for inlined bean
        if(name===undefined){
          Object.assign(newData,value)
        }else{
          newData[name] = value;
        }

      }
      return prepareInternal(newData,arguments[i],arguments[i+1]);
    }
    var apiCall = function(a,b,c){
      var prepared;
      if(arguments.length>0){
        prepared = prepare.apply(apiCall,arguments)
      }else{
        prepared = apiCall
      }
      return new Promise((resolve,reject)=>{
		//the reject will be handled by the group
        var toPush = prepared.prepare(resolve)
        toPush.rejector = reject;
        autogroup.push(toPush);
      })

    }
    return Object.assign(apiCall,{
      prepare:prepare,
      setOptions:setOptions,
      noPg:function(){
        return setOptions({progressbar:'none'})
      },
      //those one for internal use only
      definition:definition,
      success:success,
      error:error,
      data:data,
      options:options
    });
  }

  function flattenQuery(data,prefix,flattenned){
    flattenned = flattenned || {formData:new FormData(),urlencoded:{}};
    if(data===undefined ||data===null){
    }else if(Array.isArray(data)){
      if(data.length===1 && (data[0] instanceof File ||typeof data[0]!=='object')){
        flattenQuery(data[0],prefix,flattenned);
      }else{
        data.forEach((value,idx)=>{
          flattenQuery(value,(prefix?prefix+".":"")+idx,flattenned);
        })
      }

    }else if(data instanceof File || data instanceof Blob){ //TODO verify for blob
      if(data.type==="" && data.name.toLowerCase().endsWith(".heic")){
        data = new File([data], data.name, {type: "image/heic"})
      }
      flattenned.formData.append(prefix,data);
      flattenned.hasFile = true;
    }else if(data instanceof Date){
      flattenned.formData.append(prefix,data.toISOString());
      flattenned.urlencoded[prefix]=data.toISOString();
    }else if(typeof data === 'object'){
      $.each(data,function(key,value){
        flattenQuery(value,(prefix?prefix+".":"")+key,flattenned);
      });
    }else if(typeof data === 'function'){
    }else{
      flattenned.formData.append(prefix,data);
      flattenned.urlencoded[prefix]=data;
    }
    return flattenned.hasFile?flattenned.formData:flattenned.urlencoded;
  }

  function flattenForm(form){
    var formData = {};
    $(form).find(":input[name]:not(:disabled)").each(function(idx,input){
      var
        $input = $(input),
        name = input.name,
        value = $input.val();

      if(input.type==='file'){
        if($input.prop("empty")){
          value = '$empty';
        }else if(input.medias!==undefined){
          value = input.medias.map(media=>media.pictureUrl)
        }else{
          if($input.prop("multiple")){
            value = input.files;
          }else{
            value = input.files[0]
          }
        }
        if(!value){
          value = $input.attr("data-value")
        }
      }

      //FIXME find where it is used and replace by customFiles
      if(input.file){
        value = input.file;
      }
      if(input.customFiles){
        if(input.customFiles.length){
          value = input.customFiles.map(obj=>obj instanceof File?obj:obj.pictureUrl);
        }else{
          value = "$empty";
        }
      }

      if(input.type==='checkbox' && !$input.prop("checked")) return;

      //use of getAttribute('type') instead of .type because for unknown type, the .type is changed to 'text'
      if(input.getAttribute('type')==='datetime-local'){
        try{
          var
            date = new Date(value),
            zone = input.getAttribute('timezone');
          if(zone){
            date = fromZone(date,zone)
          }
          value = date.toISOString();
        }catch(e){
          value='$empty'
        }
      }
      //use of getAttribute('type') instead of .type because for unknown type, the .type is changed to 'text'
      if(input.getAttribute('type')==='date'){
        var time = $input.attr('data-time')||'00:00:00Z';
        try{
          value = new Date(value+'T'+time).toISOString();
        }catch(e){
          value='$empty'
        }
      }
      if(input.getAttribute('type')==='amount'){
        value = CustomInput.getAmountValue(input as HTMLInputElement);
      }

      if(Array.isArray(value)){
        if(value.length===0){
          value = '$empty';
        }
      }else{
        value = [value]
      }
      if(name.indexOf('$i')>-1){
        if(value!=='$empty'){
          $.each(value,function(idx,value){
            formData[name.replace('$i',idx)] = [value];
          })
        }
      }else if($input.attr('data-type')==='json'){
        if(value){
          var parsed = JSON.parse(value);
          if(Array.isArray(parsed)){
            if(parsed.length===0){
              formData[name] = '$empty'
            }else{
              for(var i=0;i<parsed.length;i++){
                formData[name+'.'+i] = parsed[i];
              }
            }
          }else{
            //TODO never tested, should find deeper Array
            formData[name] = parsed;
          }

        }
      }else{

        formData[name] = (formData[name]||[]).concat(value);
      }

    });
    return formData;
  }

  function buildGroupApiCall(requests,success,error,options,data){
    success = success||$.noop;
    error = chainError(defaultErrorHandler,error);
    if(options===undefined){
      options =  requests[0].options;
    }
    if(data===undefined){
      data = Object.assign({partnerScope:FizConfig.CONFIG_PARTNER_TYPE},requests[0].data);
      for(var i=1;i<requests.length;i++){
        var
          prefix = a0i(i),
          request = requests[i];
        data[prefix+"call"] = request.definition.api;
        Object.entries(request.data).forEach(function([i,item]){
          data[prefix+i] = item;
        });

      }
    }

    function execute(data,success,error){
      var
        pgDef = options.progressbar,
        currentProgressBar = (typeof pgDef==='function'?pgDef():(typeof pgDef==='string'?progressbar[pgDef]:pgDef))||progressbar.auto(),
        dataToSend = flattenQuery(data),
        hasFile = dataToSend instanceof FormData,
        //if upload we try to ping the server to keep the session alive
        pingInterval = hasFile?setInterval(function(){
          $.ajax(API,{
            dataType :'json',
            cache:false,
            xhrFields: {
              withCredentials: true
            },
            crossDomain: true,
            type: "GET",
            });
        },300000):undefined,
        xhr = !hasFile?undefined:function() {
          var xhrobj = $.ajaxSettings.xhr();
          //TODO because of this code there is an OPTIONS call before the good one, find why and a way to remove it
		      //those lines does not change anything
          //xhrobj.withCredentials = true;
          //xhrobj.crossDomain = true;
          if (xhrobj.upload) {
              xhrobj.upload.addEventListener('progress', function(event) {
                if (event.lengthComputable) {
                  var
                    position = event.loaded || event.position,
                    total = event.total,
                    percent = position / total;
                  currentProgressBar.progress(percent*0.99);
                }
              }, false);
          }
          return xhrobj;
        };
       currentProgressBar.progress(0);

       var
         firstApiCall = requests[0].definition.api,
         callUrl = API+'/'+firstApiCall,
         headers = {
          "Authorization":getAuthorization()
         },
         timeout = requests.reduce((p,n)=>p+(n.options?.additiveTimeout??0), options.timeout ||(hasFile?3600000: 20000));

       
       $.ajax(callUrl,{
        dataType :'json',
        headers:headers,
        cache:false,
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        timeout,
        xhr: xhr,
        type: "POST",
        data: dataToSend,
        processData: hasFile?false:undefined, //because we use FormData
        contentType: hasFile?false:undefined, //because we use FormData
        success:function(obj){
          try{
            if(obj.a99 && obj.a99.cn==="webapiurl"){
              Storage.sessionSet("webapiurl",obj.a99.r.r);
            }
          }catch(e){}

          var resultsObj = [],i,currentError;
          try{
            for(i=0;i<requests.length;i++){
              var
                request = requests[i],
                rejector = request.rejector||noop;
              try{
                resultsObj[i] = request.success(obj[a0i(i)]);
                //console.log("decoding"+a0i(i),resultsObj[i])

              }catch(e){

                try{
                  (request.error||rethrow)(e);
                  rejector(e)
                }catch(newErr){
                  rejector(newErr)
                  currentError = currentError||newErr;

                }
              }

            }
            if(currentError) throw currentError;
            success.apply(groupApiCall,resultsObj);
          }catch(e){
            console.log(e)
            error.call(groupApiCall,e);
          }finally{
            clearInterval(pingInterval);
            currentProgressBar.close();
          }
        },
        error:function(jqXHR, textStatus, errorThrown){
          try{
            //means http error, server down, adblock, timeout...
            if(jqXHR.readyState === 0){
              if(textStatus==="timeout"){
                throw new HTTPError("httptimeout",errorThrown);
              }
              throw new HTTPError("http0",textStatus+" "+errorThrown);
            }else if(jqXHR.readyState === 4){
              throw new HTTPError("http"+jqXHR.status,errorThrown);
            }
            throw new Error(errorThrown);
          }catch(e){
            //try to see if request handler can handle that
            var currentError;
            for(let i=0;i<requests.length;i++){
              var
                request = requests[i],
                rejector = request.rejector||noop;
              try{
                rejector(e)
                if((request.error||rethrow)(e)){
                  return;
                };
              }catch(newErr){
                currentError = currentError||newErr;
              }
            }
            if(currentError){
              error.call(groupApiCall,currentError);
            }

          }finally{
            clearInterval(pingInterval);
            currentProgressBar.close();
          }
        }
      });
    }
    function groupApiCall(param,newSuccess,newError){
      var newData =  Object.assign({},data);
      if(param===undefined){
        return execute(newData,newSuccess||success,newError||error);
      }else if(param.nodeName){
        newData.transactional = true;
        //data from form override what was prepared, it is not just appended
        Object.assign(newData,flattenForm(param));
        return buildGroupApiCall(requests,newSuccess||success,newError||error,options,newData)()
      }else if(typeof param==='function'){
        newError = newSuccess;
        newSuccess = param;
      }else{
        Object.assign(newData,param);
      }
      return execute(newData,newSuccess||success,newError||error);
    }
    return Object.assign(groupApiCall,{
      setOptions:function(newOptions){
        //TODO extends options
        return buildGroupApiCall(requests,success,error,newOptions,data)
      },
      success:success,
      data:data,
      options:options
    });
  }

var SRV = {
  group : function(requests,success,error){
    return buildGroupApiCall(requests,success,error);
  },
  aftergroup : function(callback){
    if(autogroup.apis.length){
      autogroup.after.push(callback);
    }else{
      callback();
    }

  },
  setGroupOptions :function(options){
    autogroup.options = options;
  },
  types:fizapilib.types,
  setDefaultErrorHandler:function(def){
    defaultErrorHandler = def;
  },
  flattenForm:flattenForm,
  methodsTs:fizapilib.methodsTs
};


Object.entries(fizapilib.methods).forEach(([key,value])=>{
  SRV[key] = buildApiCall(value,{},value.decoder,null,{});
})


export {SRV , HTTPError};